<ng-container *ngIf="embeddedInQuotation; else inCard">
  <adjustment-invoicing
    [project]="project"
    [inputSubProject]="inputSubProject"
    [collapsed]="collapsed"
    [embeddedInQuotation]="embeddedInQuotation"
    [invoiceSent]="invoiceSent"
    (outputInvoice)="outputInvoice.emit()"
  ></adjustment-invoicing>
</ng-container>

<ng-template #inCard>
  <mat-card class="top-card mat-elevation-z0 overflowHidden">
    <adjustment-invoicing
      [project]="project"
      [inputSubProject]="inputSubProject"
      [collapsed]="collapsed"
      [embeddedInQuotation]="embeddedInQuotation"
      [invoiceSent]="invoiceSent"
      (outputInvoice)="outputInvoice.emit()"
    ></adjustment-invoicing>
  </mat-card>
</ng-template>
